import React, { useState, useEffect, useRef } from "react";
import Select from 'react-select';
import { Form  } from 'react-bootstrap';
import { Multiselect as MultiSelectDou } from "multiselect-react-dropdown";
import { MultiSelect } from "react-multi-select-component";
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS

//https://github.com/srigar/multiselect-react-dropdown
//https://github.com/hc-oss/react-multi-select-component

const MultiSelectDropdown = (props = {}) => {
  const DropdownMode = "rMS";//react-multi-select-component
    let state = {
        options: [{name: 'Option 1️⃣', id: 1},{name: 'Option 2️⃣', id: 2}],
        selectedValues:[],
        singleSelect: false,
        showCheckbox:true,
        selectionLimit:-1,
        placeholder:"",
        disablePreSelectedValues: (props.disablePreSelectedValues ? props.disablePreSelectedValues : false),
        displayValue:"name",
        emptyRecordMsg:"N/A",
        groupby: "",
        id:"",
        className:"",
        hidePlaceholder:false,
        hideSelectedChips:false,
        styles:{width:"250px", marginLeft:"10px"},
        SelectAllPlaceHolder:"Select All",
        AllItemsSelectedPlaceHolder:"Select All",
        TriggerSelectEventOnDataPopulate: false,
        FireSelectEventOnEveryItemChange: (props.FireSelectEventOnEveryItemChange ? props.FireSelectEventOnEveryItemChange:false),
        DropdownMode: "rMS",
        rsMenuWidth: "",
        rsIsClearable: false,
        setSelectedValues: false
    };

    state = {...state, ...props.options};

    
    const currentlyselected = [];
    for(let i = 0; i < state.options?.length; i++) {
      currentlyselected.push({ label: state.options[i][state.displayValue], value: state.options[i]["id"], disabled: false });//.push(state.options[i]["id"]);
    }

    const [selected, setSelected] = useState([]);
    const [singleselected, setSingleSelected] = useState("");
    const [isChanged, setisChanged] = useState(false);
    const [rS_SelectedValue, setrS_SelectedValue] = useState({});
    const [rsMenuOpen, setRSMenuOpen] = useState(false);

    const looseArrayIncludes = (array, valueToCheck) => {
      for (const element of array) {
        if (element.id == valueToCheck) {
          return true;
        }
      }
      return false;
    }
    const IsCalledFromPageReload = useRef(true);
    const rSSelectContainerRef = useRef(null);

    useEffect(() => {
      IsCalledFromPageReload.current = true;
    }, []);

    useEffect(() => {
      if(rsMenuOpen && rSSelectContainerRef.current && state.className.includes('RouteDropdownToolbarClass'))
      {
        const container = rSSelectContainerRef.current.getBoundingClientRect();
        const screenWidth = window.innerWidth;
        const selectDropdown = document.getElementsByClassName('css-1nmdiq5-menu')[0];
        if(container.left < 10){
          selectDropdown.style.left = 0;
          selectDropdown.style.right = 'auto';
        }
        else if(container.right >= (screenWidth-400)){
          selectDropdown.style.left = 'auto';
          selectDropdown.style.right = 0;
        }
        else
        {
          selectDropdown.style.left = 'auto';
          selectDropdown.style.right = 'auto';
        }
      }
    }, [rsMenuOpen]);

     useEffect(() => {
      try{
        setSelected(currentlyselected);
        
        if(state.TriggerSelectEventOnDataPopulate) {
          if(state.options?.length > 0){
            SingleSelectOnChange({ target: { value: state.options[0]["id"] } });
          }
        }
        if(state.DropdownMode === "rS"){
          if(props.options.selectedValues?.length > 0){
            setrS_SelectedValue(props.options.selectedValues[0]);
          }
          else{
            setrS_SelectedValue({});
          }
        }
        if(props.singleselect === "true") {
          let selectedvalLocal="";
          try {
            for(let i = 0; i < state.selectedValues?.length; i++) {
              if(looseArrayIncludes(state.options, state.selectedValues[i])) {
                selectedvalLocal = state.selectedValues[i];
              }
            }
            if(selectedvalLocal === ""){
              selectedvalLocal = state?.options[0]["id"];
            }
            setSingleSelected(selectedvalLocal);
            
            let arrSelected = [];
            arrSelected.push(selectedvalLocal.toString());
            if(typeof props.SelectionChangeCallback === "function") {
              IsCalledFromPageReload.current = false;
              if(typeof props.IsPageReloadCall === 'function')
                props.IsPageReloadCall(IsCalledFromPageReload.current);
              props.SelectionChangeCallback(arrSelected);
            }
          }
          catch(e) { }
        }
      }
      catch(err){console.log(err); }
     },[props.options]);

     useEffect(()=>{
      try{
        if(state.disablePreSelectedValues)
        {
          const userSelected = [];
          for(let i = 0; i < props.options.selectedValues?.length; i++) {
            userSelected.push({ label: props.options.selectedValues[i].name, value: props.options.selectedValues[i].id, disabled: false });//.push(state.options[i]["id"]);
          }
          setSelected(userSelected);
        }

        if(state.setSelectedValues)
        {
          const userSelected = [];
        
          for(let i = 0; i < props.options.selectedValues?.length; i++) {
            userSelected.push({ label: props.options.selectedValues[i].name, value: props.options.selectedValues[i].id, disabled: false });//.push(state.options[i]["id"]);
            
          }
          setSelected(userSelected);
        }
      }
      catch(err){console.log(err); setSelected([]);}

     }, [props.options.selectedValues]);


    function onSelect(selectedList, selectedItem) {
    }
    
    function onRemove(selectedList, removedItem) {
    }

    function onSelectMultiSelect(selectedList) {
      try{
        let arrSelected = [];
        for (let i = 0; i < selectedList?.length; i++){
          arrSelected.push(selectedList[i]["value"]);
        }
        if(typeof props.SelectionChangeCallback === "function"){
          props.SelectionChangeCallback(arrSelected);
        }
      }
      catch(err){console.log(err);}
    };

    function SingleSelectOnChange(event) {
      try{
        IsCalledFromPageReload.current = false;
        if(typeof props.IsPageReloadCall === "function"){
          props.IsPageReloadCall(IsCalledFromPageReload.current);
        }
        const newValue = event.target.value;
        setSingleSelected(newValue);
        let arrSelected = [];
        arrSelected.push(newValue);
        if(typeof props.SelectionChangeCallback === "function"){
          props.SelectionChangeCallback(arrSelected);
        }
      }
      catch(err){console.log(err);}
    };

    const handleRSDropDownChange = (item) => {
      try{
        if(!item){
          props.SelectionChangeCallback("-1");
        }
        else{
          props.SelectionChangeCallback(item.value);
        }
      }
      catch(err){console.log(err);}
    };

    if(props.singleselect === "true") {
      //alert(singleselected);
      return (
        <span className="MultiSelectDropdownCommon" style={state.styles}>
        <Form.Select aria-label="" value={singleselected} className={props.SingleSelectClass || ''}  onChange={SingleSelectOnChange}>
        {state.options.map(({ id, name }, index) => (<option value={id} key={id} >{name}</option>) )}
          </Form.Select>
        </span>
      );
    }
    else if(state.DropdownMode === "rMS") {
      let reactMSOpts = [];
      for(let i = 0; i < state.options?.length; i++) {
        reactMSOpts.push({ label: state.options[i][state.displayValue], value: state.options[i]["id"], disabled: state.options[i]["disabled"] ?? false });
      }

      return (
        <span className="MultiSelectDropdownCommon" style={state.styles}>
          <MultiSelect
            options={reactMSOpts}
            onMenuToggle={(isopen) => {  
                if(isopen === false && !state.FireSelectEventOnEveryItemChange && isChanged === true)  
                { 
                  onSelectMultiSelect(selected); 
                } 
                else if(isopen === true){
                  setisChanged(false);
                }   
              } 
            }
            value={selected}
            onChange={(value) => { setSelected(value); if(state.FireSelectEventOnEveryItemChange) { onSelectMultiSelect(value); } setisChanged(true); }}
            labelledBy="test"
            className={state.className}
            ClearSelectedIcon={null}
            hasSelectAll={state.SelectAllPlaceHolder==""?false:true}
            overrideStrings={{
              "allItemsAreSelected":state.AllItemsSelectedPlaceHolder,
              "clearSearch": "Clear Search",
              "clearSelected": "Clear Selected",
              "noOptions": state.placeholder + "(No options)",
              "search": "Search",
              "selectAll": state.SelectAllPlaceHolder,
              "selectAllFiltered": "Select All (Filtered)",
              "selectSomeItems": state.placeholder,
              "create": "Create",
            }}
          />
          </span>
      );
    }
    else if(state.DropdownMode === "rS") {
      let customStyles = {};
      if(state.rsMenuWidth !== "") {
          customStyles = {
            menu: (provided) => ({
                ...provided,
                minWidth: state.rsMenuWidth,
                width: state.rsMenuWidth  // Set width to 100% of the parent element
            })
        };
      }
      return (
        <span  style={state.styles} ref={rSSelectContainerRef}>
          <Select
            options={state.options}
            onChange={handleRSDropDownChange}
            value={rS_SelectedValue}
            // defaultValue={options[0]}
            styles={customStyles}
            className={state.className}
            // isMulti={true}
            // isSearchable={true}
            onMenuOpen={(e)=>{setRSMenuOpen(true);}}
            onMenuClose={(e)=>{setRSMenuOpen(false);}}
            isClearable={state.rsIsClearable}
            // closeMenuOnSelect={false}
            // placeholder="Select your favorite fruits"
            // onChange={(selectedOptions) => {
            //   console.log('Selected:', selectedOptions);
            // }}
          />
        </span>
      );
    }
    else {
      let styles = {};

      if(state.hideSelectedChips) {
        styles = {...styles, ...{ chips: {display:"none"} }};
      }

      return ( 
        <span className="MultiSelectDropdownCommon" style={state.styles}>
          <MultiSelectDou
            options={state.options} // Options to display in the dropdown
            selectedValues={state.selectedValues} // Preselected value to persist in dropdown
            onSelect={onSelect} // Function will trigger on select event
            onRemove={onRemove} // Function will trigger on remove event
            displayValue="name" // Property name to display in the dropdown options
            showCheckbox={state.showCheckbox} // Property name to display in the dropdown options
            hidePlaceholder={state.hidePlaceholder} // Property name to display in the dropdown options
            style={styles}
            placeholder={state.placeholder} // Property name to display in the dropdown options
          />
        </span>
      );
    }
  };
  
  export default MultiSelectDropdown;
  